import Container from '@ui/container/container';
import { JSX, Suspense, lazy } from 'react';
import { IconProps } from './types';

const _Icons = lazy(() => import('./icon-wrapped'));

export const SvgLemonadeGradient = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <defs>
        <linearGradient
          id="svg_lemonade_gradient"
          x1="0"
          y1="22"
          x2="12.0004"
          y2="1.99999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFFD62" />
          <stop offset="1" stopColor="#FF6AE6" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const IconFallback = ({
  size,
  height,
  width,
  loaderSize,
  skeletonLoader,
}: {
  skeletonLoader?: boolean;
  size?: number;
  height?: number;
  width?: number;
  loaderSize?: { height: number; width: number };
}) => {
  return (
    <Container
      background="inherit"
      skeletonLoader={skeletonLoader}
      // skeletonLoaderBackground={{
      //   start: skeletonLoader.start,
      //   end: skeletonLoader.end,
      // }}
      /* Note: fallback height and width prevents loading jank */
      width={`${loaderSize?.width ?? size ?? width ?? 18}px`}
      height={`${loaderSize?.height ?? size ?? height ?? 18}px`}
    />
  );
};

export default function Icon(props: IconProps): JSX.Element {
  return (
    <Suspense
      fallback={
        <IconFallback
          skeletonLoader={props.skeletonLoader}
          size={props?.size}
          width={props?.width}
          height={props?.height}
          loaderSize={props?.loaderSize}
        />
      }
    >
      <_Icons {...props} />
    </Suspense>
  );
}
